import { c as _c } from "react/compiler-runtime";
import OfferProductTypeSelector from 'modules/funnels/funnel/components/offer-settings/offer-product-type-selector';
import { DigitalOfferEditInterface, DigitalOfferViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/digital-offer-interface';
import { PhysicalOfferEditInterface, PhysicalOfferViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface';
import { OfferTypeEnum } from 'modules/funnels/funnel/enums/offer-type-enum';
import React, { FC, useEffect, useState, type JSX } from 'react';
import { SectionMessage } from 'shared/components/section-message';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ProductWrapperProps {
  children: (type: OfferTypeEnum) => JSX.Element;
  digitalProduct: DigitalOfferViewInterface['digitalProduct'] | DigitalOfferEditInterface['digitalProduct'];
  product: PhysicalOfferViewInterface['product'] | PhysicalOfferEditInterface['product'];
}
const ProductWrapper: FC<ProductWrapperProps> = t0 => {
  const $ = _c(14);
  const {
    children,
    digitalProduct,
    product
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [type, setType] = useState();
  let t1;
  let t2;
  if ($[0] !== digitalProduct || $[1] !== product) {
    t1 = () => {
      if (digitalProduct) {
        setType(OfferTypeEnum.digital);
      } else {
        if (product) {
          setType(OfferTypeEnum.physical);
        } else {
          setType(undefined);
        }
      }
    };
    t2 = [digitalProduct, product];
    $[0] = digitalProduct;
    $[1] = product;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = type_0 => {
      setType(type_0);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== type) {
    t4 = <OfferProductTypeSelector selected={type} onChange={t3} />;
    $[5] = type;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t || $[9] !== type) {
    t5 = type ? <div className="bg-[rgb(var(--brand-primary-subtle))] flex w-full grow flex-col gap-5 px-4 py-7">{children(type)}</div> : <SectionMessage>{t("dashboard.funnel.configuration.offer.no_product_selected")}</SectionMessage>;
    $[7] = children;
    $[8] = t;
    $[9] = type;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex flex-col px-4 lg:px-0">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default ProductWrapper;